let selectedPlanB = null;
let selectedProtectionB = 'advanced';

document.addEventListener("DOMContentLoaded", function() {
  window.plansPageVersion = 'B';

  $(".plans-hero-b-slideshow").slick({
    slidesToShow: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev' id='plans-hero-b-slideshow-prev'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
    nextArrow:
      "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
  });

  document.getElementById('plans-hero-b-slideshow-prev').click()
  document.getElementById('plans-hero-b-slideshow-prev').click()

  $(".plans-hero-b-slideshow").show();

  const plansPageHero = document.getElementById('plans-hero-b-content');

  const getPlanCard = (planId) => {
    const planTrigger = plansPageHero.querySelector(`#${planId}`);
    return planTrigger ? planTrigger.closest('li') : null;
  };

  const residentialPlan = getPlanCard('plans-hero-b-choose-plan-residential-plan');
  const travelPlan = getPlanCard('plans-hero-b-choose-plan-travel-plan');

  const plansPageChoosePlanStepOne = document.getElementById('plans-hero-b-step-one');
  const plansPageStepTwo = document.getElementById('plans-hero-b-step-two');

  const plansPageCheckoutButton = plansPageHero.querySelector('#checkout-button-b');
  const plansPageCheckoutLinkResidentialStandard = plansPageHero.querySelector('#cb-residential-standard-b');
  const plansPageCheckoutLinkResidentialAdvanced = plansPageHero.querySelector('#cb-residential-advanced-b');
  const plansPageCheckoutLinkTravelStandard = plansPageHero.querySelector('#cb-travel-standard-b');
  const plansPageCheckoutLinkTravelAdvanced = plansPageHero.querySelector('#cb-travel-advanced-b');

  if (!residentialPlan || !travelPlan || !plansPageCheckoutButton) {
    console.error('Plan selection controls are missing.');
    return;
  }

  const selectResidentialPlan = () => {
    selectedPlanB = 'residential';

    residentialPlan.classList.add('plans-hero-b-card-active');
    travelPlan.classList.remove('plans-hero-b-card-active');

    residentialPlan.querySelector('button span').innerText = 'RESIDENTIAL SELECTED';
    residentialPlan.querySelector('button svg').style.display = 'block';
    travelPlan.querySelector('button span').innerText = 'GET STARTED — $129.95/MO';
    travelPlan.querySelector('button svg').style.display = 'none';

    residentialPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-b-slideshow').slick('slickGoTo', 0);

    updateBottomBarPlan('residential')

    setTimeout(() => {
      plansPageStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const selectTravelPlan = () => {
    selectedPlanB = 'travel';

    travelPlan.classList.add('plans-hero-b-card-active');
    residentialPlan.classList.remove('plans-hero-b-card-active');

    residentialPlan.querySelector('button span').innerText = 'GET STARTED — $99.95/MO';
    residentialPlan.querySelector('button svg').style.display = 'none';
    travelPlan.querySelector('button span').innerText = 'TRAVEL SELECTED';
    travelPlan.querySelector('button svg').style.display = 'block';

    travelPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-b-slideshow').slick('slickGoTo', 1);

    updateBottomBarPlan('travel')

    setTimeout(() => {
      plansPageStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const openStandardCheckout = (link) => {
    const url = new URL('https://nomad-internet.chargebee.com/hosted_pages/checkout');
    for (let index = 0; link.hasAttribute('data-cb-item-' + index); index++) {
      url.searchParams.set('subscription_items[item_price_id][' + index + ']', link.getAttribute('data-cb-item-' + index));
      const quantity = link.getAttribute('data-cb-item-' + index + '-quantity');
      if (quantity) url.searchParams.set('subscription_items[quantity][' + index + ']', quantity);
    }
    url.searchParams.set('coupon_ids[0]', 'PLANSPAGECHECKOUT');
    url.searchParams.set('subscription[cf_Device_IMEI]', 'pending');
    url.searchParams.set('subscription[cf_SIM_ID_ICCID]', 'pending');
    window.location.assign(url.toString());
  };

  const checkout = (plan, protection) => {
    if (plan === 'residential') {
      if (protection === 'standard') {
        openStandardCheckout(plansPageCheckoutLinkResidentialStandard);
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkResidentialAdvanced.click();
      } else {

      }
    } else if (plan === 'travel') {
      if (protection === 'standard') {
        openStandardCheckout(plansPageCheckoutLinkTravelStandard);
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkTravelAdvanced.click();
      } else {

      }
    } else {
      Toastify({
        text: "Please choose a plan",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
      }).showToast();

      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const advancedProtectionCheckbox = document.getElementById('plans-hero-b-step-two-advanced-protection-checkbox');

  advancedProtectionCheckbox.addEventListener('change', (event) => {
    if (event.target.checked) {
      selectedProtectionB = 'advanced';
    } else {
      selectedProtectionB = 'standard';
    }
  });

  residentialPlan.addEventListener('click', selectResidentialPlan);
  travelPlan.addEventListener('click', selectTravelPlan);
  plansPageCheckoutButton.addEventListener('click', () => checkout(selectedPlanB, selectedProtectionB))

  residentialPlan.querySelector('button').disabled = false;
  travelPlan.querySelector('button').disabled = false;
  plansPageCheckoutButton.disabled = false;

  const searchParams = new URLSearchParams(window.location.search);

  switch (searchParams.get('plan')) {
    case 'residential':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
    case 'travel':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
  }

  initializeChargebeeProductTracking('cb-residential-standard-b', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced-b', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard-b', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced-b', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
});
